const validateEmail = (email: string) =>
  /^(?=.{6,254}$)[a-zA-Z0-9!#$%&'*+\\/=()<>\[\]:,;?^_{|}~`-]+(\.[a-zA-Z0-9!#$%&'*+\\/=()<>:,;?^_{|}~`-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z0-9-]{2,63})$/.test(
    email
  );

export default validateEmail;
